/*
  F.14 (#213) — el parche hidrogel entra solo en el carrito al comprar un pack.

  La mitad de tienda (descuento automatico "compra 1 de Tratamientos completos,
  llevate 1 parche al 100%") solo sabe poner a 0 EUR una linea que YA este en el
  carrito: Shopify no la crea. Crearla es trabajo del tema, y es esto.

  La linea de regalo lleva la propiedad _regalo. El guion bajo la oculta al
  cliente en carrito y checkout, y sirve para distinguirla del mismo parche
  comprado a proposito: son dos lineas distintas y el cliente puede tener las dos.
*/
class RegaloPack extends HTMLElement {
  connectedCallback() {
    this.variante = parseInt(this.dataset.variante, 10);
    this.packs = (this.dataset.packs || '').split(',').map(Number).filter(Boolean);
    if (!this.variante || !this.packs.length) return;

    this.ocupado = false;
    this.sincroniza();
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.sincroniza());
  }

  async sincroniza() {
    // Nuestras propias llamadas no publican cartUpdate, pero el cliente puede
    // encadenar cambios rapidos: sin el cerrojo se anadirian dos parches.
    if (this.ocupado) return;
    this.ocupado = true;

    try {
      const carrito = await fetch(`${theme.routes.cart_url}.js`).then((r) => r.json());
      const hayPack = carrito.items.some((l) => this.packs.includes(l.product_id));
      const regalo = carrito.items.find((l) => l.properties && l.properties._regalo);

      if (hayPack && !regalo) {
        await this.anade();
      } else if (!hayPack && regalo) {
        await this.cambia(regalo.key, 0);
      } else if (regalo && regalo.quantity !== 1) {
        await this.cambia(regalo.key, 1);
      }
    } catch (e) {
      console.error(e);
    } finally {
      this.ocupado = false;
    }
  }

  anade() {
    const secciones = this.secciones();
    return fetch(theme.routes.cart_add_url, {
      ...fetchConfig(),
      body: JSON.stringify({
        items: [{ id: this.variante, quantity: 1, properties: { _regalo: 'pack' } }],
        sections: secciones.map((s) => s.seccion).join(','),
        sections_url: window.location.pathname
      })
    })
      .then((r) => r.json())
      .then((estado) => this.repinta(estado, secciones));
  }

  cambia(clave, cantidad) {
    const secciones = this.secciones();
    return fetch(theme.routes.cart_change_url, {
      ...fetchConfig(),
      body: JSON.stringify({
        id: clave,
        quantity: cantidad,
        sections: secciones.map((s) => s.seccion).join(','),
        sections_url: window.location.pathname
      })
    })
      .then((r) => r.json())
      .then((estado) => this.repinta(estado, secciones));
  }

  secciones() {
    const lista = [
      { id: 'mini-cart', seccion: 'mini-cart', selector: '.shopify-section' },
      { id: 'cart-icon-bubble', seccion: 'cart-icon-bubble', selector: '.shopify-section' },
      { id: 'mobile-cart-icon-bubble', seccion: 'mobile-cart-icon-bubble', selector: '.shopify-section' },
      { id: 'main-cart-items', seccion: document.getElementById('main-cart-items')?.dataset.id, selector: '.js-contents' },
      { id: 'main-cart-footer', seccion: document.getElementById('main-cart-footer')?.dataset.id, selector: '.cart__footer' }
    ];
    return lista.filter((s) => s.seccion && document.getElementById(s.id));
  }

  // Deliberadamente NO usamos MiniCart.renderContents: abre el cajon, y esto
  // corre tambien al cargar la pagina. El regalo se pone solo, sin interrumpir.
  repinta(estado, secciones) {
    if (!estado || !estado.sections) return;
    secciones.forEach((s) => {
      const destino = document.getElementById(s.id);
      const html = estado.sections[s.seccion];
      if (!destino || !html) return;
      const trozo = new DOMParser().parseFromString(html, 'text/html').querySelector(s.selector);
      if (trozo) destino.innerHTML = trozo.innerHTML;
    });
  }
}

customElements.define('regalo-pack', RegaloPack);
